export default __webpack_public_path__ + "static/media/LinkedIn.cc795a99.svg";